import useNotificationHandler from "hooks/useNotificationHandler";
import { QUERY_KEYS } from "library/shared";
import { IEmployeeEnrollment } from "library/types";
import { UseQueryResult, useQuery, useQueryClient } from "react-query";
import api from "service/api";

type Params = {
  countryCode: number;
  clientInternalNumberGOS: number;
  benefitImplementationTag: number;
  benefitPackageTag: number;
  employeeDependentTag: number;
  employeeLoginEmailAddress: string;
  employeeEnrollmentTag: number;
  enabled?: boolean;
};

const getDependentEnrollment = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitImplementationTag,
  benefitPackageTag,
  employeeDependentTag,
  employeeLoginEmailAddress,
  employeeEnrollmentTag,
}: Params) => {
  const response = await api.get(
    `/employeeenrollment/dependent/${countryCode}/${clientInternalNumberGOS}/${benefitImplementationTag}/${benefitPackageTag}/${employeeLoginEmailAddress}/${employeeDependentTag}/${employeeEnrollmentTag}`
  );

  return response.data;
};
export function useGetDependentEnrollment({
  countryCode,
  clientInternalNumberGOS,
  employeeLoginEmailAddress,
  employeeDependentTag,
  benefitImplementationTag,
  benefitPackageTag,
  employeeEnrollmentTag,
  enabled = true,
}: Params): UseQueryResult<IEmployeeEnrollment> {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useQuery<IEmployeeEnrollment, Error>(
    [
      QUERY_KEYS.dependentEnrollment,
      countryCode,
      clientInternalNumberGOS,
      employeeLoginEmailAddress,
      benefitImplementationTag,
      benefitPackageTag,
      employeeDependentTag,
      employeeEnrollmentTag,
    ],
    () =>
      getDependentEnrollment({
        countryCode,
        clientInternalNumberGOS,
        employeeLoginEmailAddress,
        benefitImplementationTag,
        benefitPackageTag,
        employeeDependentTag,
        employeeEnrollmentTag,
      }),
    {
      staleTime: 0,
      refetchOnMount: true,

      // cacheTime: 0,
      enabled: enabled,
      onError: (error: any) => {
        // errorHandler({
        //   label: "Error",
        //   type: notificationTypes.error,
        //   value: "Error while loading offer item data",
        //   errors: error?.message,
        //   fieldName: "",
        // });
        handleAddAxiosErrorNotification(error);
      },
    }
  );
}

export const useInvalidateDependentEnrollment = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.dependentEnrollment,
    });
};
